
import type { PropType } from 'vue'
import { defineComponent, getCurrentInstance } from 'vue'
import { EpbText } from '../../shared/epb-text'

export interface TopPerformer {
  query: string
  queryCount: number
  clickCount: number
  clickCountPct: number
}

export interface TopPerformersMessages {
  stats: {
    time: string
    times: string
    clicks: string
    ctr: string
  }
}

export default defineComponent({
  name: 'TopPerformersItems',
  components: {
    EpbText,
  },
  props: {
    performers: {
      type: Array as PropType<Array<TopPerformer>>,
      required: true,
    },
    messages: {
      type: Object as PropType<TopPerformersMessages>,
      required: true,
    },
  },
  setup() {
    const ctx = getCurrentInstance()
    if (!ctx) {
      throw new Error("'ctx' is not defined")
    }

    const baseClass = 'epb-top-performers-items'

    const formatNumber = (value: number, options = {}): string => {
      return ctx.proxy.$epb.utils.formatNumber(
        value,
        { maximumFractionDigits: 0, ...options },
        true,
      )
    }

    const formatPercentage = (value: number): string => {
      return `${ctx.proxy.$epb.utils.formatNumber(value, { maximumFractionDigits: 2 }, true)}%`
    }

    return {
      baseClass,
      formatNumber,
      formatPercentage,
    }
  },
})
